import React, { useState, useRef, useEffect } from "react";
import { useReactToPrint } from 'react-to-print';
import  PhieuInDanhSachNo  from './PhieuInDanhSachNo';
import ChoVayApi from "service/choVayApi";
import { format } from 'date-fns';
import { pushNotification } from "../../../../utils/notifications";

export const BtnIn = ({ dataSearch }) => { 
    const componentToPrintRef = useRef();
    const [isFetching, setIsFetching] = useState(false);
    const [fullListToPrint, setFullListToPrint] = useState(null);
    const triggerPrint = useReactToPrint({
        content: () => componentToPrintRef.current,
        onAfterPrint: () => setFullListToPrint(null),
    });
    useEffect(() => {
        if (fullListToPrint) {
            triggerPrint();
        }
    }, [fullListToPrint, triggerPrint]);

    const handleFetchAndPrint = async () => {
        if (isFetching) return;
        setIsFetching(true);
        try {
            const params = {
                ...dataSearch,
                pageIndex: -1,
                pageSize: 0,
                dateTo: dataSearch.dateTo ? format(dataSearch.dateTo, 'dd/MM/yyyy') : format(new Date(), 'dd/MM/yyyy'),
            };
            const res = await ChoVayApi.getDanhSachNo(params);
            if (res.status === 200 && res.data) {
                setFullListToPrint(res.data);
            } else {
                pushNotification("Không thể tải dữ liệu để in!", "error", "TOP_CENTER", 2000);
            }
        } catch (error) {
            console.error("Lỗi khi tải dữ liệu in:", error);
            pushNotification("Lỗi khi tải dữ liệu in!", "error", "TOP_CENTER", 2000);
        } finally {
            setIsFetching(false);
        }
    };

    return (
        <>
            <a type="button" className="con-bgnew color-print1" onClick={handleFetchAndPrint}>
                <img src="/app-assets/images/logo-print-v2.png" title="In phiếu"/>
            </a>
            {fullListToPrint && (
                <div style={{ display: "none" }}>
                    <PhieuInDanhSachNo 
                        ref={componentToPrintRef} 
                        listHopDong={fullListToPrint} 
                        dataSearch={dataSearch}
                    />
                </div>
            )}
        </>
    );
};